import { render } from "./ClientIcon.vue?vue&type=template&id=5d1a6788&scoped=true"
import script from "./ClientIcon.vue?vue&type=script&lang=js"
export * from "./ClientIcon.vue?vue&type=script&lang=js"

import "./ClientIcon.vue?vue&type=style&index=0&id=5d1a6788&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1a6788"]])

export default __exports__